import React from 'react';
import Card from '../../../../ui/Card';
import { AboutTheBuildingModule } from '../../AboutTheBuildingModule/AboutTheBuildingModule';

export const AboutBuildingSection = () => {
  return (
    <section>
      <Card variant="default" size="md" title="About the building">
        <AboutTheBuildingModule />
      </Card>
    </section>
  );
};
